var service = {
  url : 'https://lambda.garlican.com/papi/',
  match : {
    "Hang Seng Composite Industry Index - Information Technology" : "IT",
    "Hang Seng Composite Industry Index - Telecommunications" : "TS",
    "Hang Seng Composite Industry Index - Financials" : "FN",
    "Hang Seng Composite Industry Index - Conglomerates" : "MIX",
    "Hang Seng Composite Industry Index - Consumer Staples" : "CS",
    "Hang Seng Composite Industry Index - Consumer Discretionary" : "CD",
    "Hang Seng Composite Industry Index - Properties & Construction" : "RE",
    "HSI"  : "HSI",
    "Hang Seng Composite Industry Index - Industrials" : "IN",
    "Hang Seng Composite Industry Index - Healthcare" : "HC",
    "Hang Seng Composite Industry Index - Materials" : "MA",
    "Hang Seng Composite Industry Index - Energy" : "EN",
    "Hang Seng Composite Industry Index - Utilities" : "UT",
  },
  getTableApi : (obj) =>{
    var url = service.url + "getTableApi"
    var body = {}
    if(obj) {
      body = obj
    } 
    return fetch(
        url, 
        {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body : JSON.stringify(body)
        }
    ).then(
        (response) => response.json()
    )
  },
  getSymbolApi : (obj) =>{
    var url = service.url + "getSymbolApi"
    var body = {}
    if(obj) {
      body = obj
    } 
    return fetch(
        url, 
        {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body : JSON.stringify(body)
        }
    ).then(
        (response) => response.json()
    )
  },
  getIndexApi : (obj) =>{
    var url = service.url + "getIndexApi"
    var body = {}
    if(obj) {
      body = obj
    } 
    return fetch(
        url, 
        {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body : JSON.stringify(body)
        }
    ).then(
        (response) => response.json()
    )
  },
  getIndexRank : (obj) =>{
    var url = service.url + "getIndexRank"
    var body = {}
    if(obj) {
      body = obj
    } 
    return fetch(
        url, 
        {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body : JSON.stringify(body)
        }
    ).then(
        (response) => response.json()
    )
  },
}



export default service